import { Stack, Typography } from '@mui/material'
import { IconButton, Icons, SkeletonText } from 'utoniq-ui'

import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { State } from './'

export type ConsoleItemDescriptionProps = {
  item: State['item']
  loading: State['loading']
}
export const ConsoleItemDescription: Cell<ConsoleItemDescriptionProps> = ({
  item,
  loading,
}) => {
  const { t } = useTranslation('consoleItemDetail')
  const { generatePath, routerPages } = useRouter()
  const issuableNft = !!item?.nft?.chains
  if (loading) {
    return (
      <CellFrame sx={{ pt: 3, width: 250 }}>
        <SkeletonText variant="medium" width="100%" />
        <SkeletonText variant="small" width="100%" />
      </CellFrame>
    )
  }
  return (
    <CellFrame
      sx={{ display: 'grid', gridTemplateColumns: '1fr', pt: 1, gap: 2, px: 5 }}
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        {issuableNft && (
          <IconButton.Nft
            href={generatePath(routerPages.OwnedItemNftItems, {
              itemId: item?.id || '#',
            })}
          />
        )}
        <Stack alignItems="center" spacing={1}>
          <Typography variant="h6">{item?.title}</Typography>
          {item?.skuSettings && (
            <ItemStatusTagCell number={item.skuSettings.units?.length || 0} />
          )}
        </Stack>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        {!!item?.price && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="overline" color="text.hint">
              {t('price')}
            </Typography>
            {item?.paymentType === 'prepaid_point' || !item?.paymentType ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Icons.Point fontSize="xSmall" />
                <Typography variant="overline" color="text.secondary">
                  {item?.formattedPrice}
                </Typography>
              </Stack>
            ) : (
              <Typography variant="overline">
                ￥{item?.formattedPrice}
              </Typography>
            )}
          </Stack>
        )}
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="overline" color="text.hint">
            {t('remainingQuantityPerTotal', '残り数量/全数量')}
          </Typography>
          <Typography variant="overline">
            {item?.formattedRemainingNumber ?? '0'}/{item?.issuedNumber ?? '∞'}
          </Typography>
        </Stack>
      </Stack>
    </CellFrame>
  )
}

type ItemStatusTagCellProps = {
  number: number
}
const ItemStatusTagCell: Cell<ItemStatusTagCellProps> = ({ number }) => (
  <CellFrame
    sx={{
      py: 1,
      px: 2,
      borderRadius: '34px',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'grey.400',
    }}
  >
    <Typography variant="overline" color="text.secondary" component="p">
      SKU（{number}）
    </Typography>
  </CellFrame>
)
